// Formato de precios del flujo de pago (#1680, R26): CLP `$59.900`, USD `US$60`.
// Fuente única: PlanesYPago, SuscripcionPanel y el bloqueo dicen lo mismo.
// Un monto utilizable: número finito. null/undefined/""/NaN NO lo son (revisor r2 N1: un `precio`
// que el backend no mandaba salía como "$NaN"). Los formatos devuelven "" y quien arma la frase
// decide cómo decirlo sin cifra (`conMonto`).
export const montoValido = (monto) =>
  monto !== null && monto !== undefined && monto !== "" && Number.isFinite(Number(monto));

export const formatoClp = (monto) =>
  montoValido(monto) ? `$${Math.round(Number(monto)).toLocaleString("es-CL")}` : "";

export const formatoUsd = (monto) =>
  montoValido(monto) ? `US$${Number(monto).toLocaleString("es-CL", { maximumFractionDigits: 2 })}` : "";

export const formatoPrecio = (monto, moneda) =>
  moneda === "USD" ? formatoUsd(monto) : formatoClp(monto);

// Arma "<antes> <monto> <después>" sin dejar huecos: sin monto la frase es solo "<antes><después>".
export const conMonto = (antes, monto, despues = "") =>
  [antes, monto, despues].filter((t) => t !== "" && t != null).join(" ");

export const PLAN_NOMBRE = {
  turno: "Turno",
  pro: "Pro",
  max: "Max",
  max_plus: "Max+",
  clinica: "Clínica",
};

// Nombre del plan para mostrar; nunca el id crudo (un plan nuevo sin nombre dice "Tu plan").
export const nombrePlan = (id) => PLAN_NOMBRE[id] || "Tu plan";
